import { isFilledObject } from '../../AppHelpers'

export default class CurrentShowAsset {
  constructor(obj) {
    if (isFilledObject(obj)) {
      this.id = obj.id
      this.type = obj.type
      this.name = obj.name
      this.shortName = obj.shortened_name
      this.schedule = obj.schedule
      this.programmeID = obj.programme_id
      this.start = obj.start
      this.finish = obj.finish

      this.imageBG = obj.artwork_with_background
      this.imageLogo = obj.watermarked_artwork
      this.image = obj.artwork
    }
  }
}
